import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { SearchAppBar } from './BiasInfoAppBar';
import { Box, Grid } from '@mui/material';
import { OrderBiasInfoColumn } from './OrderBiasInfoColumn';
import { SubbiasInfoDetailColumn } from './SubbiasInfoDetailColumn';
import { SubbiasStatisticsColumn } from './SubbiasStatisticsColumn';
import { AnnotationsColumn } from './AnnotationsColumn';
import { History } from './History';
import { useState } from 'react';
import { setIndividualAreas } from '../../../actions/individualAreas';
import { AllowedAreas } from './AllowedAreas';
import { useDispatch, useSelector } from 'react-redux';
import { resetBiases } from '../../../actions/biases';
import { adminAreas, orderAreasSimple } from '../../../helpers/utils';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

export const setColorStyle = () => ({ border: `1px solid transparent` });

export const HeaderSection = ({ text }) => (
	<div style={{ textAlign: 'center' }}>
		<p style={{ fontSize: '24px', margin: '2px 0' }}>
			<b>{text}</b>
		</p>
	</div>
);

export const ItemText = ({ subtitle, text = '' }) => (
	<div>
		<small>
			<b>{subtitle}</b>
		</small>
		{text?.length > 0 && <p>{text}</p>}
	</div>
);

export const SubtitleItemText = ({ title, first = false }) => (
	<div>
		<p
			style={{
				fontSize: '21px',
				margin: `${first ? '0px' : '30px'} 0 -15px 0`,
			}}
		>
			<b>{title}</b>
		</p>
		<hr />
	</div>
);

export const BiasInfo = ({
	order = null,
	open,
	handleClose,
	handleGetIndividualAreas = null,
	bias = null,
	setCurrentBias2 = null,
	biases = [],
	numberOfBiases = 0,
	refreshOrder = null,
	refreshBiasTable = null,
	refreshBias = null,
	individualAreas = [],
	rowId = 0,
	setCurrentRowId = null,
}) => {
	// Current subbias (it is used in the 2nd and 3rd column)
	const [currentSubbias, setCurrentSubbias] = useState(null);

	// Current bias
	const [currentBias, setCurrentBias] = useState(bias);

	// Dispatch
	const dispatch = useDispatch();

	// Counter biases row
	const [counterBiasRow, setCounterBiasRow] = useState(rowId - 1);

	useEffect(() => {
		// Get new current bias
		const newCurrentBias = biases[counterBiasRow];
		// Set new current bias
		setCurrentBias(newCurrentBias);
		setCurrentBias2(newCurrentBias);
		setCurrentRowId(counterBiasRow);
		// Get new current bias' individual areas
		handleGetIndividualAreas(newCurrentBias?.id);
		// Reset current subbias
		setCurrentSubbias(null);
		// ERROR: agüas, que te sale un error de REDUX del state mutation
		// dispatch(setIndividualAreas(null));
	}, [counterBiasRow]);

	// Store: user
	const { user = null } = useSelector((state) => state);
	// Store: biases
	const { biases: subbiasesStore = [] } = useSelector(
		(state) => state.biases
	);

	// Handle clean allowed areas
	const handleCleanAllowedAreas = (array) => {
		return orderAreasSimple(array).filter(
			(item) =>
				// Those areas can't be touched
				!adminAreas.includes(item.name)
		);
	};

	const handleCloseFull = () => {
		// Close dialog
		handleClose();
		// Refresh order
		refreshOrder();
		// Refresh bias table
		refreshBiasTable();
		// Reset biases
		dispatch(resetBiases());
		// Empty individual areas
		// ERROR: agüas, que te sale un error de REDUX del state mutation
		// dispatch(setIndividualAreas(null));
		// Set current subbias to null
		setCurrentBias2(null);
		// Reset bias, subbias and row counters
		setCurrentSubbias(null);
		setCurrentBias(null);
		setCurrentRowId(0);
		setCounterBiasRow(rowId - 1);
	};

	return (
		<div>
			{currentBias && user && individualAreas && (
				<Dialog
					fullScreen
					open={open}
					onClose={handleCloseFull}
					TransitionComponent={Transition}
				>
					{/* App bar with search */}
					<SearchAppBar
						title={`PARTIDA (${
							counterBiasRow < 1 ? 1 : counterBiasRow + 1
						}/${numberOfBiases}): ${currentBias?.key}`}
						handleClose={handleCloseFull}
						handleGetIndividualAreas={handleGetIndividualAreas}
						numberOfBiases={numberOfBiases}
						counterBiasRow={counterBiasRow}
						setCounterBiasRow={setCounterBiasRow}
						logistics_is_done={currentBias?.logistics_is_done}
					/>

					{/* Content */}
					<Box sx={{ flexGrow: 1 }}>
						<Grid
							container
							style={{
								...setColorStyle(),
							}}
						>
							{/* ORDER & BIAS INFORMATION */}
							<OrderBiasInfoColumn
								bias={currentBias}
								rowId={rowId}
							/>

							{/* SUBBIASES (SIZES) & STATISTICS */}
							<SubbiasStatisticsColumn
								bias={currentBias}
								counterBiasRow={counterBiasRow}
								currentSubbias={currentSubbias}
								setCurrentSubbias={setCurrentSubbias}
							/>

							{/* SUBBIAS INFORMATION DETAIL OR ALLOWED AREAS */}
							{user?.area?.name === 'Logística' ? (
								<AllowedAreas
									order={order}
									handleClose={handleCloseFull}
									individualAreas={handleCleanAllowedAreas(
										individualAreas
									)}
									setIndividualAreas={setIndividualAreas}
									setCurrentBias={setCurrentBias}
									setCurrentSubbias={setCurrentSubbias}
									currentSubbias={currentSubbias}
									bias={currentBias}
								/>
							) : (
								<SubbiasInfoDetailColumn
									individualAreas={individualAreas}
									setIndividualAreas={setIndividualAreas}
									order={order}
									bias={currentBias}
									refreshBias={refreshBias}
									subbias={currentSubbias}
									setCurrentSubbias={setCurrentSubbias}
								/>
							)}
						</Grid>

						{/* If there aren't selected subbbiases then show it */}
						{subbiasesStore?.length === 0 && (
							<Grid
								container
								style={{
									...setColorStyle(),
								}}
							>
								{/* HISTORY LIST */}
								{currentBias && <History bias={currentBias} />}

								{/* ANNOTATIONS LIST */}
								{currentSubbias && (
									<AnnotationsColumn
										subbias={currentSubbias}
										bias={currentBias}
									/>
								)}

								{user?.area?.name === 'Logística' && (
									<SubbiasInfoDetailColumn
										individualAreas={individualAreas}
										setIndividualAreas={setIndividualAreas}
										order={order}
										bias={currentBias}
										refreshBias={refreshBias}
										subbias={currentSubbias}
										setCurrentSubbias={setCurrentSubbias}
									/>
								)}
							</Grid>
						)}
					</Box>
				</Dialog>
			)}
		</div>
	);
};
